export default function($) {
  $('.js-tabs').each(function() {
    const $container = $(this);
    const $triggers = $container.find('.js-tab-trigger');
    const $panels = $container.find('.js-tab-panel');

    $triggers.on('click', function() {
      const target = $(this).data('tab');
      $triggers.removeClass('is-active');
      $panels.removeClass('is-active');
      $(this).addClass('is-active');
      $container.find('.js-tab-panel[data-tab="' + target + '"]').addClass('is-active');
    });
  });
}
